import { createReducer } from 'redux-act';
import {
  FOLDERS_FETCH_INIT,
  FOLDERS_FETCH_SUCCESS,
  FOLDERS_FETCH_FAIL,
  FOLDERS_CREATE_INIT,
  FOLDERS_CREATE_SUCCESS,
  FOLDERS_CREATE_FAIL,
  FOLDERS_UPDATE_INIT,
  FOLDERS_UPDATE_SUCCESS,
  FOLDERS_UPDATE_FAIL,
  FOLDERS_DELETE_INIT,
  FOLDERS_DELETE_SUCCESS,
  FOLDERS_DELETE_FAIL,
  FOLDERS_BULK_COPY_INIT,
  FOLDERS_BULK_COPY_SUCCESS,
  FOLDERS_BULK_COPY_FAIL,
  FOLDERS_BULK_DELETE_INIT,
  FOLDERS_BULK_DELETE_SUCCESS,
  FOLDERS_BULK_DELETE_FAIL,
  FOLDERS_MOVE_INIT,
  FOLDERS_MOVE_SUCCESS,
  FOLDERS_MOVE_FAIL,
  FOLDERS_CLEAR_DATA,
} from 'state/actions/folders';

const initialState = {
  list: [],
  loading: false,
  error: null,
  created: false,
  updated: false,
  deleted: false,
};

export const foldersReducer = createReducer(
  {
    [FOLDERS_FETCH_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [FOLDERS_FETCH_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      list: payload.folders,
      error: null,
    }),
    [FOLDERS_FETCH_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),

    [FOLDERS_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
      created: false,
      error: null,
    }),
    [FOLDERS_CREATE_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      created: true,
      error: null,
    }),
    [FOLDERS_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      created: false,
      error: payload.error,
    }),

    [FOLDERS_UPDATE_INIT]: (state) => ({
      ...state,
      loading: true,
      updated: false,
      error: null,
    }),
    [FOLDERS_UPDATE_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      updated: true,
      error: null,
    }),
    [FOLDERS_UPDATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      updated: false,
      error: payload.error,
    }),

    [FOLDERS_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
      deleted: false,
      error: null,
    }),
    [FOLDERS_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      deleted: true,
      list: state.list.filter((folder) => folder._id !== payload.id),
      error: null,
    }),
    [FOLDERS_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      deleted: false,
      error: payload.error,
    }),

    [FOLDERS_BULK_COPY_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [FOLDERS_BULK_COPY_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: null,
    }),
    [FOLDERS_BULK_COPY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),

    [FOLDERS_BULK_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
      deleted: false,
      error: null,
    }),
    [FOLDERS_BULK_DELETE_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      deleted: true,
      error: null,
    }),
    [FOLDERS_BULK_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      deleted: false,
      error: payload.error,
    }),

    [FOLDERS_MOVE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [FOLDERS_MOVE_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: null,
    }),
    [FOLDERS_MOVE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),

    [FOLDERS_CLEAR_DATA]: () => initialState,
  },
  initialState
);

export default foldersReducer;
